import React from 'react';
import {SelectField, SelectInput} from 'react-admin';

const type = [
    {id: 'NAVI_PARKING', name: 'Navi Parking'},
]

export const EPartnerField = (props) => (
    <SelectField source={props.source} choices={type} {...props} />
)

export const EPartnerInput = (props) => (
    <SelectInput source={props.source} choices={type} {...props} />
)
